import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class FastPhonicsDashboardChartRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductFp = 'fast_phonics'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      product,
      uiScope,
      scopedData,
      period,
      scopedStudents,
      ...stats,
    }
  }

  makeStatsRequests = (product: LegacyProductFp, scope: StudentsScope, period: NormalizedInterval) => {
    return RSVP.hash({
      totalUsageOverTime: this.studentEvents.totalUsageOverTime(product, scope, period),
    })
  }
}
